import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { isUndefined } from 'util';

@Component({
  selector: 'nec-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class NecPaginationComponent implements OnInit, OnChanges {
  @Input() curPage: number;
  @Input() totalPages: number;
  @Output() updateFunc = new EventEmitter<number>();

  private maxSize = 5;
  // æ¾ç¤ºé¡µæ°çæå°å¼,æå¤§å¼,ä»¥åååèå´
  private min = 1;
  private max = 1;
  private range = Math.floor(this.maxSize / 2);

  endEllipsis: boolean; // åé¡µè¿å¤ï¼åé¢ççç¥å·
  frontEllipsis: boolean; // åé¡µè¿å¤ï¼åé¢ççç¥å·
  inputPageNum: number;
  // è¿è¡åå§å,å°æ¾ç¤ºçé¡µæ°åè¡¨ç½®ç©º,è®¾ç½®åæ¶æå¤æ¾ç¤º5ä¸ªé¡µæ°
  pages = [];

  constructor(private el: ElementRef) {
  }

  ngOnInit() {
    this.update(false);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!isUndefined(changes.totalPages)) {
      if (typeof this.totalPages !== 'undefined') {
        this.update(false);
      }
    }
    if (!isUndefined(changes.curPage)) {
      this.inputPageNum = this.curPage;
      this.update(false);
    }
  }

  // é¡µæ°è·³è½¬çå½æ°
  go2Page(pageNum) {
    if (pageNum >= 1 && pageNum <= this.totalPages && pageNum !== this.curPage) {
      this.curPage = parseInt(pageNum, 0);
      this.update(true);
    }
  }

  // ç´æ¥è·³è½¬å°æå®é¡µæ°
  go2InputPageNum() {
    this.inputPageNumCheck();
    if (typeof this.inputPageNum !== 'undefined' && !isNaN(this.inputPageNum) && this.inputPageNum !== this.curPage) {
      this.go2Page(this.inputPageNum);
    }
  }

  inputPageNumCheck() {
    if (this.inputPageNum > this.totalPages || this.inputPageNum < 1) {
      this.inputPageNum = this.curPage;
    }
  }

  // æ´æ°æä½, æ´æ°å½åé¡µæ°ä»¥åæ¾ç¤ºçé¡µæ°èå´ todo éè¦ç²¾ç®
  update(callFunc) {
    // ç¡®å®æ¾ç¤ºé¡µæ°çæå°å¼åæå¤§å¼
    this.min = Math.max(1, this.curPage - this.range);
    this.max = Math.min(this.totalPages, this.curPage + this.range);

    if (this.min === 1) {
      this.max = Math.max(this.max, this.min + this.range * 2);
      this.totalPages = Math.max(1, this.totalPages);
      this.max = Math.min(this.totalPages, this.max);
    }

    if (this.max === this.totalPages) {
      this.min = Math.min(this.min, this.max - this.range * 2);
      this.min = Math.max(1, this.min);
    }

    // ç¡®å®æ¯å¦è¦æ¾ç¤ºçç¥å·
    this.frontEllipsis = this.min !== 1;
    this.endEllipsis = this.max !== this.totalPages;

    // æ´æ°é¡µæ°èå´
    this.pages = [];
    for (let i = this.min; i <= this.max; i++) {
      this.pages.push(i);
    }

    // è°ç¨ä¼ éè¿æ¥çæ´æ°å½æ°
    this.inputPageNum = this.curPage;
    if (callFunc) {
      this.updateFunc.emit(this.curPage);
      this.el.nativeElement.querySelector('#paginationNum').blur();
    }
  }

}
